import { z } from "zod";

export const GoodVibesGranularitySchema = z.enum(["daily", "threeDays", "weekly", "monthly", "quarterly"]);
export type GoodVibesGranularity = z.infer<typeof GoodVibesGranularitySchema>;

export const GoodVibesHistoryPointSchema = z.object({
    date: z.string(),
    count: z.number().nullable()
});
export type GoodVibesHistoryPoint = z.infer<typeof GoodVibesHistoryPointSchema>;
